import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { useMediaQuery } from "react-responsive";
import logoIcon from "../assets/logo-icon.png";
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from "@mui/material/CircularProgress"; // loader

export default function Footer() {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, []);

    const [open, setOpen] = useState(false);
    const [updateMessage, setUpdateMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubscribeEmail = async (e) => {
        e.preventDefault();

        const formData = {
            email: e.target.email.value.trim(),
        };

        // basic validation
        if (!formData.email) {
            setOpen(true);
            setUpdateMessage("Please fill in your email before submitting.");
            return;
        }

        try {
            setLoading(true);

            const res = await fetch("https://fixerfind-web2-backend.vercel.app/newsletter", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const data = await res.json();

            if (res.ok && data.success) {
                e.target.reset();
                setUpdateMessage("Thanks for Subscribing!");
            } else {
                setUpdateMessage(data.error || "Something went wrong.");
            }
        } catch (err) {
            setUpdateMessage("Network error. Please try again.");
        } finally {
            setOpen(true);
            setLoading(false);
        }
    };

    return (
        <footer className="bg-gray-100 text-gray-700"> {/*mt-16*/}
            <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">

                {/* Logo & Tagline */}
                <div>
                    <div className="flex items-center space-x-2">
                        <img
                            src={logoIcon}
                            alt="FixerFind Logo"
                            className="h-15 w-auto"
                            style={{
                                height: isMobile ? "35px" : "40px",
                                width: isMobile ? "35px" : "40px",
                                borderRadius: "25%",
                                boxShadow: "0 5px 15px rgba(0, 0, 0, 0.20)",
                            }}
                        />
                        <span
                            className="text-xl"
                            style={{
                                color: "#1e90ff",
                                fontSize: isMobile ? "1.7rem" : "1.8rem",
                                fontFamily: "Arciform, Franklin Gothic Medium, Arial Narrow, Arial, sans-serif",
                                textDecoration: "none",
                                fontWeight: "300",
                                marginTop: "5px",
                            }}
                        >
                            FixerFind
                        </span>
                    </div>
                    <p className="text-sm text-gray-500">People's fast & easy service.</p>
                </div>

                {/* Quick Links */}
                <div>
                    <h3 className="font-semibold mb-4">Company</h3>
                    <ul className="space-y-2">
                        <li><a href="/about" className="hover:text-blue-600">About Us</a></li>
                        {/* <li><a href="/services" className="hover:text-blue-600">Services</a></li> */}
                        <li><a href="/portfolio" className="hover:text-blue-600">Portfolio</a></li>
                        {/* <li><a href="/investors" className="hover:text-blue-600">Investors</a></li> */}
                        <li><a href="/legal" className="hover:text-blue-600">Legal</a></li>
                    </ul>
                </div>

                {/* Social Media */}
                <div>
                    <h3 className="font-semibold mb-4">Follow Us</h3>
                    <ul className="space-y-2">
                        <li><a href="https://www.linkedin.com/company/fixerfind/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">LinkedIn</a></li>
                        <li><a href="https://twitter.com/fixerfind" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">Twitter</a></li>
                        <li><a href="https://web.facebook.com/people/FixerFind/100093456613751/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">Facebook</a></li>
                        <li><a href="https://instagram.com/fixerfind" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">Instagram</a></li>
                        <li><a href="https://medium.com/@fixerfind" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600">Medium</a></li>
                    </ul>
                </div>

                {/* Newsletter */}
                <div>
                    <h3 className="font-semibold mb-4">Newsletter</h3>
                    <p className="text-sm mb-4">
                        Subscribe for updates, news, and offers.
                    </p>
                    <form className="flex" onSubmit={handleSubscribeEmail}>
                        <input
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            className="p-2 w-full border rounded-l-lg"
                        // minLength={6}
                        />
                        <button type="submit" className="bg-blue-600 text-white px-4 rounded-r-lg hover:bg-blue-700" disabled={loading}>
                            {loading ? <CircularProgress size={24} color="inherit" /> : "Join"}
                        </button>
                    </form>
                    <Snackbar
                        open={open}
                        autoHideDuration={6000}
                        onClose={handleClose}
                        message={updateMessage}
                        anchorOrigin={{
                            vertical: 'bottom', horizontal: 'center'
                        }}
                    />
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="bg-gray-200 text-gray-600 text-center py-4 text-sm">
                © {new Date().getFullYear()} FixerFind Digital Technologies LTD. All rights reserved.
            </div>
        </footer>
    );
}
